module.exports = __webpack_public_path__ + "img/lipchenko.6136f262.png";